"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberValue = exports.getObjectEntries = exports.getObjectValues = exports.getObjectKeys = exports.isDiff = exports.sleep = exports.makeRollingCode = exports.makeCode = exports.getFileUrl = exports.getImageUrl = exports.sortData = exports.getDuration = exports.durationMiddleware = exports.getValue = void 0;
const lodash_1 = __importDefault(require("lodash"));
const moment_1 = __importDefault(require("moment"));
const aigle_1 = __importDefault(require("aigle"));
const short_hash_1 = __importDefault(require("short-hash"));
const asyncLodash = aigle_1.default.mixin(lodash_1.default, undefined);
const getValue = (value, defaultValue) => {
    let output = defaultValue;
    if (value !== null && value !== '') {
        output = value;
    }
    return output;
};
exports.getValue = getValue;
const durationMiddleware = () => (req, res, next) => {
    const start = process.hrtime();
    lodash_1.default.set(req, 'start', start);
    next();
};
exports.durationMiddleware = durationMiddleware;
const getDuration = (start) => {
    let timeInMs = 0;
    if (start) {
        const end = process.hrtime(start);
        timeInMs = (end[0] * 1000000000 + end[1]) / 1000000;
    }
    return timeInMs;
};
exports.getDuration = getDuration;
const sortData = (data, field, reverse) => __awaiter(void 0, void 0, void 0, function* () {
    return asyncLodash
        .chain(data)
        .sortBy(field)
        .tap(reverse ? lodash_1.default.reverse : lodash_1.default.noop)
        .value();
});
exports.sortData = sortData;
const getImageUrl = ({ cdnUrl, image, size, undefinedImage, }) => {
    if (image) {
        return `${cdnUrl}/images/${size}/${image}`;
    }
    return `${cdnUrl}/static/${undefinedImage || 'dummy.png'}`;
};
exports.getImageUrl = getImageUrl;
const getFileUrl = ({ cdnUrl, file, }) => `${cdnUrl}/files/${file}`;
exports.getFileUrl = getFileUrl;
const makeCode = (input) => (0, short_hash_1.default)(input).toUpperCase();
exports.makeCode = makeCode;
const makeRollingCode = (value, lifetime) => {
    let time = (0, moment_1.default)().unix();
    time -= time % lifetime;
    return (0, exports.makeCode)(`${value}${time}`);
};
exports.makeRollingCode = makeRollingCode;
const sleep = (milliseconds) => new Promise((resolve) => {
    setTimeout(resolve, milliseconds);
});
exports.sleep = sleep;
const isDiff = (param1, param2) => lodash_1.default.isEqual(param1, param2) === false;
exports.isDiff = isDiff;
exports.getObjectKeys = Object.keys;
exports.getObjectValues = Object.values;
exports.getObjectEntries = Object.entries;
const numberValue = (input) => (input === '' ? 0 : Number(input));
exports.numberValue = numberValue;
